import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsService} from '../../core/settings.service';
import {environment} from '../../../environments/environment';
import {Cookie} from '../../helper/cookie';
import { v4 as uuidv4 } from 'uuid';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import * as fromCertificate from './store/certificate.reducers';
import {map, take} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService,
    private store: Store<fromApp.AppState>
  ) { }

  getCertificateForAudit(auditId: number) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'certificates/' + auditId.toString() + '/profile',
      {
        params: {

        }
      }
    );
  }

  getCertificateByCode(code: string) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'certificates/' + code + '/code',
      {
        params: {

        }
      }
    );
  }

  addCertificateView(certificateCode: string) {
    const language = window.navigator.language;
    const userAgent = window.navigator.userAgent;
    const resolution = window.screen.availWidth.toString() + 'x' + window.screen.availHeight.toString();
    return this.httpClient.post(
      this.settingsService.getSetting('apiHost') + 'certificate/view',
      {
        certificate_code: certificateCode,
        user_code: this.setCookieForUniqueUser(),
        language: language,
        browser: userAgent,
        resolution: resolution
      }
    );
  }

  setCookieForUniqueUser() {
    const cookie = new Cookie();
    let uid = cookie.getCookie('auditor-uid');
    if (uid === undefined) {
      uid = uuidv4();
      cookie.setCookie('auditor-uid', uid, new Date(new Date().getTime() + 3600 * 24 * 30 * 6 * 1000), '/', environment.cookiesHost);
    }

    return uid;
  }

  isCertificateActive(): Observable<boolean> {
    return this.store.select('certificate')
      .pipe(
        take(1),
        map(
          (state: fromCertificate.State) => {
            const expiryDate = new Date(state.certificate.expiry_at);
            const getActualDate = new Date().getTime();
            if (getActualDate > expiryDate.getTime()) {
              return false;
            }
            return true;
          }
        )
      );
  }
}
